<template>
    <van-overlay :show="visible" @click="visible = false">
        <div id="to-share">
            <van-image src="https://public.qiniu.xcims.com/wx_toshare.png" />
            <div/>
        </div>
    </van-overlay>
</template>

<script>
import { Overlay, Image } from 'vant';
export default {
    name: 'ToShare',
    components: {
        [Overlay.name]: Overlay,
        [Image.name]: Image
    },
    data() {
        return {
            visible: false
        }
    },
    methods: {
        show() {
            this.visible = true
        }
    }
}
</script>

<style lang="less" scope>
#to-share {
    display: flex;
    img {
        width: 50%;
        margin-left: auto;
        margin-right: 1em;
    }
}
</style>